var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGatewayDarkBlueIcon = function SvgGatewayDarkBlueIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    x: 5,
    y: 5.75,
    stroke: "#131B20",
    strokeWidth: 1.5,
    rx: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#131B20",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M8 12.75h8M12 16.75v-8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#131B20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M4.97 14.72 3 12.75m0 0 1.97-1.97M3 12.75h1.97M19.03 10.78 21 12.75m0 0-1.97 1.97M21 12.75h-1.97M14 2.75h-4M14 22.75h-4"
  })));
};
export { SvgGatewayDarkBlueIcon as ReactComponent };
export default __webpack_public_path__ + "139d79fdcb4485e4c24d33eaa7e1b5fa.svg";